import * as types from "./types";

export default {
  [types.MUTATE_RULES]: (state, payload) => {
    if (!payload || !payload.entity_id) {
      state.rules[payload?.level] = null;
      return;
    }
    const { level, entity_id, type, value, action, scale_id } = payload;
    if (!state.rules[level]) {
      state.rules[level] = {};
    }
    if (!state.rules[level][entity_id]) {
      state.rules[level][entity_id] = {};
    }
    state.rules[level][entity_id][type] = { value, action, scale_id };
  },
  [types.MUTATE_SEARCH_RESULTS]: (state, payload) => {
    state.searchResults = payload || {};
  },
  [types.SET_RULE_VIOLATION](state, violation) {
    state.ruleViolation = violation;
  },
  [types.MUTATE_RULES_BY_GROUP]: (state, payload) => {
    state.rulesByGroup = payload || [];
  }
};
